import axios, { AxiosResponse } from "axios";
import { ApiErrorHandler } from "../../../../errorHandler";
import { ErroObj } from "../../../shared/interfaces/model/errorObj.interface";
import { addTenantUserData } from "../../../shared/interfaces/model/user.interface";
import apiClient from "../../shared/api/apiClient";
import {
  recoverResponseCode,
  recoverResponseData,
} from "../../../features/card/pages/card";

export const postAddTenantUser = (payload: addTenantUserData) => {
  const data = {
    userEmail: payload.userEmail,
    products: payload.products,
    testProducts: payload.testProducts,
    name: payload.name,
    surname: payload.surname,
  };
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant/${payload.tenantId}/user`;
  return apiClient
    .post(URL, data)
    .then((response: AxiosResponse) => {
      recoverResponseCode(response.status);
      recoverResponseData(response.data);
    })
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};
